import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import { isDate } from '@ups/xplat/utils';

type FilterLike =
  | CompositeFilterDescriptor
  | FilterDescriptor
  | {
      filters?: FilterLike[];
      filter?: FilterLike;
      value?: Date;
    };

export const patchDateTo4Digits = (filter: FilterLike) => {
  if ('filters' in filter && filter.filters) {
    filter.filters.forEach((f) => patchDateTo4Digits(f));
  } else if ('filter' in filter && filter.filter) {
    patchDateTo4Digits(filter.filter);
  }

  if (
    'value' in filter &&
    filter.value &&
    isDate(filter.value) &&
    filter.value.getFullYear() < 100 /* is 2 digit */
  ) {
    filter.value = new Date(
      filter.value.getFullYear() + 2000,
      filter.value.getMonth(),
      filter.value.getDate()
    );
  }
};
